var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 60,
    viewBox: "0 0 204 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_72_21939)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.442 60H7.55834C3.39262 60 0 56.6185 0 52.5V7.5C0 3.36658 3.39262 0 7.55834 0H196.442C200.604 0 204 3.36658 204 7.5V52.5C204 56.6185 200.604 60 196.442 60Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.442 1.20075C199.936 1.20075 202.795 4.03242 202.795 7.5V52.5C202.795 55.9676 199.954 58.7993 196.442 58.7993H7.55834C4.06439 58.7993 1.20468 55.9676 1.20468 52.5V7.5C1.20468 4.03242 4.04562 1.20075 7.55834 1.20075H196.442ZM196.442 0H7.55834C3.39262 0 0 3.38155 0 7.5V52.5C0 56.6334 3.39262 60 7.55834 60H196.442C200.604 60 204 56.6334 204 52.5V7.5C204 3.38155 200.604 0 196.442 0Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.468 19.8479C106.105 19.8479 104.957 19.3729 104.049 18.4377C103.148 17.5287 102.645 16.2756 102.668 14.9963C102.668 13.631 103.133 12.4751 104.049 11.5587C104.953 10.6235 106.102 10.1484 107.464 10.1484C108.811 10.1484 109.96 10.6235 110.883 11.5587C111.799 12.505 112.264 13.6609 112.264 14.9963C112.249 16.3654 111.784 17.5213 110.883 18.434C109.978 19.3766 108.83 19.8479 107.468 19.8479ZM66.9327 19.8479C65.6004 19.8479 64.4446 19.3804 63.4988 18.4564C62.5606 17.5362 62.084 16.3729 62.084 15.0001C62.084 13.6272 62.5606 12.4639 63.4988 11.5437C64.4258 10.6198 65.5817 10.1522 66.9327 10.1522C67.5932 10.1522 68.235 10.2831 68.8505 10.5487C69.4547 10.8068 69.9463 11.1584 70.3103 11.5886L70.4004 11.6971L69.3834 12.6921L69.2783 12.5686C68.7041 11.8878 67.9347 11.5549 66.9177 11.5549C66.0095 11.5549 65.2177 11.8766 64.5646 12.5125C63.9079 13.1522 63.5739 13.9901 63.5739 15.0038C63.5739 16.0175 63.9079 16.8554 64.5646 17.4951C65.2177 18.131 66.0095 18.4527 66.9177 18.4527C67.886 18.4527 68.7003 18.131 69.3346 17.4951C69.7099 17.121 69.9426 16.5973 70.0251 15.9352H66.7638V14.5362H71.4249L71.4437 14.6634C71.4775 14.8991 71.5113 15.1422 71.5113 15.3666C71.5113 16.6572 71.121 17.7008 70.3479 18.4714C69.4697 19.3841 68.3213 19.8479 66.9327 19.8479ZM120.828 19.6497H119.391L114.989 12.6285L115.026 13.8928V19.6459H113.589V10.3504H115.229L115.274 10.4215L119.413 17.035L119.376 15.7744V10.3504H120.828V19.6497ZM96.6669 19.6497H95.2108V11.7494H92.6851V10.3504H99.1889V11.7494H96.6632V19.6497H96.6669ZM91.4992 19.6497H90.0468V10.3504H91.4992V19.6497ZM83.3366 19.6497H81.8843V11.7494H79.3586V10.3504H85.8623V11.7494H83.3366V19.6497ZM78.4391 19.6347H72.8698V10.3504H78.4391V11.7494H74.3259V14.3006H78.0375V15.6846H74.3259V18.2357H78.4391V19.6347ZM105.115 17.4764C105.764 18.1235 106.552 18.4489 107.468 18.4489C108.41 18.4489 109.179 18.131 109.821 17.4764C110.459 16.8405 110.782 16.0063 110.782 15.0001C110.782 13.9938 110.459 13.1559 109.825 12.5237C109.175 11.8766 108.383 11.5512 107.472 11.5512C106.53 11.5512 105.76 11.8691 105.122 12.5237C104.484 13.1597 104.161 13.9938 104.161 15.0001C104.161 16.0063 104.48 16.8442 105.115 17.4764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.533 32.6336C98.9863 32.6336 96.1116 35.3157 96.1116 39.0152C96.1116 42.681 99.0051 45.3967 102.533 45.3967C106.079 45.3967 108.954 42.696 108.954 39.0152C108.954 35.3157 106.079 32.6336 102.533 32.6336ZM102.533 42.868C100.593 42.868 98.9225 41.267 98.9225 39.0002C98.9225 36.6997 100.596 35.1324 102.533 35.1324C104.473 35.1324 106.143 36.6997 106.143 39.0002C106.147 41.282 104.473 42.868 102.533 42.868ZM88.5232 32.6336C84.9767 32.6336 82.102 35.3157 82.102 39.0152C82.102 42.681 84.9955 45.3967 88.5232 45.3967C92.0697 45.3967 94.9444 42.696 94.9444 39.0152C94.9444 35.3157 92.066 32.6336 88.5232 32.6336ZM88.5232 42.868C86.583 42.868 84.9129 41.267 84.9129 39.0002C84.9129 36.6997 86.5867 35.1324 88.5232 35.1324C90.4635 35.1324 92.1335 36.6997 92.1335 39.0002C92.1335 41.282 90.4635 42.868 88.5232 42.868ZM71.8528 34.5825V37.2832H78.3566C78.1577 38.7982 77.6548 39.9167 76.8855 40.6835C75.9322 41.6336 74.4611 42.666 71.8679 42.666C67.871 42.666 64.7449 39.4491 64.7449 35.4653C64.7449 31.4815 67.871 28.2645 71.8679 28.2645C74.0258 28.2645 75.5982 29.1137 76.7654 30.1985L78.6869 28.2832C77.0656 26.7346 74.9077 25.5488 71.8829 25.5488C66.3999 25.5488 61.7988 30.0002 61.7988 35.4503C61.7988 40.9154 66.3961 45.3518 71.8829 45.3518C74.8439 45.3518 77.0656 44.3867 78.822 42.5688C80.6121 40.7845 81.1788 38.267 81.1788 36.2359C81.1788 35.6037 81.13 35.0351 81.0287 34.5526H71.8491C71.8528 34.5488 71.8528 34.5825 71.8528 34.5825ZM140.039 36.6847C139.503 35.2521 137.881 32.6187 134.556 32.6187C131.261 32.6187 128.522 35.2034 128.522 39.0002C128.522 42.5837 131.231 45.3817 134.875 45.3817C137.803 45.3817 139.506 43.5975 140.208 42.5501L138.035 41.0987C137.315 42.1648 136.313 42.8643 134.89 42.8643C133.453 42.8643 132.447 42.2134 131.779 40.9304L140.339 37.3955C140.339 37.3992 140.039 36.6847 140.039 36.6847ZM131.31 38.8169C131.242 36.3518 133.231 35.0987 134.654 35.0987C135.776 35.0987 136.71 35.6486 137.029 36.4491L131.31 38.8169ZM124.356 45.0002H127.167V26.2521H124.356V45.0002ZM119.74 34.0513H119.638C119.004 33.2995 117.8 32.6187 116.261 32.6187C113.067 32.6187 110.125 35.4204 110.125 39.0189C110.125 42.6024 113.052 45.3705 116.261 45.3705C117.781 45.3705 119.004 44.686 119.638 43.9192H119.74V44.8356C119.74 47.2708 118.434 48.5837 116.328 48.5837C114.606 48.5837 113.536 47.3493 113.101 46.3169L110.658 47.3344C111.36 49.0177 113.232 51.1012 116.325 51.1012C119.62 51.1012 122.412 49.1673 122.412 44.4503V33.0002H119.755V34.0513C119.759 34.0513 119.74 34.0513 119.74 34.0513ZM116.512 42.868C114.572 42.868 112.951 41.2521 112.951 39.0189C112.951 36.767 114.572 35.1361 116.512 35.1361C118.434 35.1361 119.924 36.7857 119.924 39.0189C119.942 41.2521 118.438 42.868 116.512 42.868ZM153.201 26.2521H146.479V45.0002H149.29V37.9004H153.204C156.316 37.9004 159.374 35.6523 159.374 32.0837C159.374 28.5152 156.327 26.2521 153.201 26.2521ZM153.283 35.282H149.286V28.8481H153.283C155.389 28.8481 156.578 30.58 156.578 32.065C156.578 33.5351 155.374 35.282 153.283 35.282ZM170.64 32.6C168.599 32.6 166.493 33.5014 165.623 35.4653L168.115 36.4977C168.651 35.4653 169.635 35.1137 170.674 35.1137C172.13 35.1137 173.601 35.9815 173.635 37.5301V37.7284C173.132 37.4441 172.029 37.0102 170.708 37.0102C168.017 37.0102 165.289 38.4765 165.289 41.2259C165.289 43.7433 167.495 45.3593 169.954 45.3593C171.841 45.3593 172.881 44.5102 173.53 43.5264H173.631V44.9778H176.341V37.7957C176.341 34.4516 173.849 32.6 170.64 32.6ZM170.288 42.868C169.368 42.868 168.081 42.4192 168.081 41.267C168.081 39.8157 169.687 39.2658 171.057 39.2658C172.295 39.2658 172.881 39.5314 173.616 39.898C173.414 41.5812 171.988 42.8531 170.288 42.868ZM186.226 33.0002L182.999 41.1324H182.897L179.553 33.0002H176.529L181.546 44.368L178.687 50.686H181.614L189.334 33.0002H186.226ZM160.924 45.0002H163.735V26.2521H160.924V45.0002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7024 11.3002C15.2671 11.7678 15.0156 12.4823 15.0156 13.4174V46.5858C15.0156 47.5209 15.2671 48.2354 15.7174 48.6843L15.8338 48.7853L34.4782 30.2017V29.7865L15.8187 11.1992L15.7024 11.3002Z",
    fill: "url(#paint0_linear_72_21939)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6814 36.4154L34.4629 30.2171V29.7832L40.6814 23.585L40.8165 23.6673L48.1722 27.8343C50.2776 29.0164 50.2776 30.969 48.1722 32.166L40.8165 36.3331L40.6814 36.4154Z",
    fill: "url(#paint1_linear_72_21939)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8156 36.3329L34.4619 30L15.7012 48.6995C16.388 49.4327 17.5401 49.515 18.8273 48.8005L40.8156 36.3329Z",
    fill: "url(#paint2_linear_72_21939)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8175 23.6667L18.8293 11.2178C17.542 10.4846 16.3862 10.5856 15.7031 11.3188L34.4639 29.9996L40.8175 23.6667Z",
    fill: "url(#paint3_linear_72_21939)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6811 36.1982L18.843 48.5648C17.6233 49.2643 16.5349 49.2157 15.8331 48.5798L15.7168 48.6958L15.8331 48.7967C16.5349 49.4289 17.6233 49.4813 18.843 48.7818L40.8312 36.3329L40.6811 36.1982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1736 31.9489L40.6641 36.1983L40.7992 36.3329L48.1548 32.1658C49.2094 31.5673 49.7273 30.7818 49.7273 30C49.6635 30.7182 49.1268 31.399 48.1736 31.9489Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8286 11.4354L48.1725 28.0514C49.1257 28.5863 49.6624 29.2858 49.7449 30.0003C49.7449 29.2185 49.227 28.4329 48.1725 27.8344L18.8286 11.2185C16.7232 10.0177 15.0156 11.0202 15.0156 13.418V13.6349C15.0156 11.2334 16.7232 10.2496 18.8286 11.4354Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_72_21939",
    x1: 32.8058,
    y1: 13.0596,
    x2: 2.95366,
    y2: 21.0398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_72_21939",
    x1: 50.9178,
    y1: 30.0002,
    x2: 14.5037,
    y2: 30.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_72_21939",
    x1: 37.3607,
    y1: 33.446,
    x2: 13.5008,
    y2: 73.7357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_72_21939",
    x1: 10.979,
    y1: 0.26778,
    x2: 21.6238,
    y2: 18.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_21939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play_store.255e7977361c8f8b2fc3dda648bc213a.svg";
export { ForwardRef as ReactComponent };